import React from "react";

const EmptyCartIcon = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 22C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22Z"
        stroke="#BF1A1C"
        strokeWidth="1"
      />
      <path
        d="M19 22C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20C18.4477 20 18 20.4477 18 21C18 21.5523 18.4477 22 19 22Z"
        stroke="#BF1A1C"
        strokeWidth="1"
      />
      <path
        d="M2.05 2.05H4.05L6.71 14.47C6.81942 14.9248 7.07444 15.3315 7.43382 15.6198C7.79321 15.9082 8.23720 16.0619 8.69 16.05H18.51C18.9628 16.0619 19.4068 15.9082 19.7662 15.6198C20.1256 15.3315 20.3806 14.9248 20.49 14.47L22 7.05H5.12"
        stroke="#BF1A1C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7L10 11M10 7L14 11"
        stroke="#BF1A1C"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EmptyCartIcon;
